import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, retry, shareReplay, timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { FiservLogin } from '../../models/institution-enrollment/fiserv-login.model';
import { SnackBarService } from './snack-bar.service';

@Injectable({
    providedIn: 'root'
})
export class InstitutionErrorResolutionService {

    public closeDialogSubject = new Subject<any>();
    public errorResolutionStartedSubject = new Subject<any>();
    public refreshSummarySubject: Subject<any> = new Subject();
    public progressMessage: string;

    constructor(
        private httpClient: HttpClient,
        private snackBar: SnackBarService) {

    }

    public getErrorResolutionWidgetSession(data: string[]): Observable<FiservLogin> {
        let url = '';
        if (data['FinancialAccountId'] !== null) {
            url = `${environment.fdaConsumerUrl}/enrollment/widget/error-resolution?userFinancialInstitutionId=${data['InstitutionId']}&financialAccountId=${data['FinancialAccountId']}`; // eslint-disable-line max-len
        } else {
            url = `${environment.fdaConsumerUrl}/enrollment/widget/error-resolution?userFinancialInstitutionId=${data['InstitutionId']}`;
        }
        return this.httpClient.get<FiservLogin>(url)
            .pipe(
                catchError((error: HttpErrorResponse) => throwError(error)),
                shareReplay(1)
            );
    }

    public callFdaWebhookErrorResolutionApi(flId: string, enrollmentId: string, action: string): Observable<any> {
        return this.httpClient.get<any>(`${environment.fdaWebHookUrl}/errorresolution/${flId}/${enrollmentId}/${action}`)
        .pipe(
            timeout(5000),
            retry(1),
            catchError(error => {
                parent.postMessage({
                    code: 'cancel-fiserv-widget'
                }, '*');
                this.snackBar.openErrorSnackbar('An issue occurred when resolving your account. Please try again later.');
                return throwError(error);
            }),
            shareReplay(1)
        );
    }
}
